// extracted by mini-css-extract-plugin
export var wrapper = "Hero-module--wrapper--392Z0";
export var content = "Hero-module--content--1Q73d";
export var leadingText = "Hero-module--leading-text--2KpIT";
export var buttonWrapper = "Hero-module--button-wrapper--Jq5sQ";
export var media = "Hero-module--media--Y0WBl";